'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = void 0;
const $ = require("jquery");
class Navigation {
    constructor() {
        $('.trigShowChildMenu').on('click', (e) => {
            // 初期値にリセット
            $('.trigShowGrandChildMenu').attr('data-is-open', 'false');
            $('.bulletShowGrandChildMenu').attr('data-is-open', 'false');
            const isOpen = $(e.currentTarget).attr('data-is-open');
            const numberOfContent = $(e.currentTarget).attr("data-number");
            if (isOpen === 'false') {
                $('.trigShowChildMenu').attr('data-is-open', 'false');
                $('.bulletShowChildMenu').attr('data-is-open', 'false');
                $(e.currentTarget).attr('data-is-open', 'true');
                $(`.bulletShowChildMenu[data-number="${numberOfContent}"]`).attr('data-is-open', 'true');
            }
            else {
                $(e.currentTarget).attr('data-is-open', 'false');
                $(`.bulletShowChildMenu[data-number="${numberOfContent}"]`).attr('data-is-open', 'false');
            }
        });
        // 入試日程
        $('.trigShowGrandChildMenu').on('click', (e) => {
            const isOpen = $(e.currentTarget).attr('data-is-open');
            if (isOpen === 'false') {
                $(e.currentTarget).attr('data-is-open', 'true');
                $('.bulletShowGrandChildMenu').attr('data-is-open', 'true');
            }
            else {
                $(e.currentTarget).attr('data-is-open', 'false');
                $('.bulletShowGrandChildMenu').attr('data-is-open', 'false');
            }
        });
    }
}
exports.Navigation = Navigation;
exports.default = Navigation;
